import Spin from 'antd/lib/spin'

import 'antd/lib/spin/style'

export * from 'antd/lib/spin'

export default Spin
